import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { capitalize } from 'lodash';
import { NSBadge } from 'bricks';
import { formatDateShort } from 'ns_libs/formatter';
import { TimelineStatusBootstrapColorMap } from '../../../../constants';
import { TimelineItem } from '../../types';
import ActivityActionsMenu from '../ActivityActionsMenu/ActivityActionsMenu';

type TimelineActivityRowProps = {
    item: TimelineItem;
    onRowClick: (id: string) => void;
    onDuplicate: (item: TimelineItem) => void;
    onRequestDelete: (item: TimelineItem) => void;
};

const ReadOnlyDate = ({ value }: { value: string | null }) => (
    value
        ? <span className="text-primary">{formatDateShort(value)}</span>
        : <FontAwesomeIcon icon={faCalendarCirclePlus} size="lg" className="text-primary" />
);

const TimelineActivityRow = ({
    item, onRowClick, onDuplicate, onRequestDelete,
}: TimelineActivityRowProps) => (
    <tr
        key={item.id}
        className="timeline-row cursor--pointer"
        tabIndex={0}
        onClick={() => onRowClick(item.id)}
    >
        <td>{item.name}</td>
        <td><ReadOnlyDate value={item.target} /></td>
        <td><ReadOnlyDate value={item.completed} /></td>
        <td>
            <div className="d-flex flex-nowrap assignee-badges-container">
                {(item.assignees || []).map(assignee => (
                    <div key={assignee.id} className="assignee-badge-readonly">
                        <span>{assignee.userName || 'Unknown'}</span>
                    </div>
                ))}
            </div>
        </td>
        <td>
            <NSBadge
                className="ml-1"
                color={TimelineStatusBootstrapColorMap[item.status] || 'primary-lighten'}
            >
                {capitalize(item.status)}
            </NSBadge>
        </td>
        <td onClick={e => e.stopPropagation()}>
            <ActivityActionsMenu
                onDuplicate={() => onDuplicate(item)}
                onDelete={() => onRequestDelete(item)}
                dataTestIdPrefix="timeline-row"
            />
        </td>
    </tr>
);

export default TimelineActivityRow;
